<template>
  <div class="w12">
    <mypage-header></mypage-header>
    <div class="w12 kyc-auth-content">
      <el-form status-icon>
        <p class="title mt20 mb0">
          {{ $t("verificationReset.residence.title") }}
        </p>
        <p class="content-title">아래 내용에 따라 인증서류를 등록해 주세요.</p>
        <div class="w12 tip mt4 mb20">
          {{ $t("verificationReset.residence.notice") }}
        </div>
        <div class="w12 list_box">
          <div class="content-box">
            <p class="content-title">1. {{ $t("residence.file[0].title") }}</p>
            <div class="form-box">
              <div class="w12" flex>
                <el-input
                  size="mini"
                  :placeholder="$t(`verificationReset.residence.upload`)"
                  :value="files.idCard.name"
                ></el-input>
                <input
                  type="file"
                  name="idCard"
                  ref="idCardImg"
                  @change="setFile"
                  style="display: none"
                />
                <button
                  size="small"
                  class="black ml6"
                  type="primary"
                  @click.prevent="$refs.idCardImg.click()"
                >
                  {{ $t("verificationReset.residence.findFile") }}
                </button>
              </div>
              <div class="img-box" flex fjs fie>
                <ul>
                  <li
                    v-html="
                      `- ${$t(`verificationReset.residence.photo.content[0]`)}`
                    "
                  />
                </ul>
              </div>
            </div>
          </div>

          <div class="content-box mt20">
            <p class="content-title">2. {{ $t("residence.file[1].title") }}</p>
            <div class="form-box">
              <div class="w12" flex>
                <el-input
                  size="mini"
                  :placeholder="$t(`verificationReset.residence.upload`)"
                  :value="files.withId.name"
                ></el-input>
                <input
                  type="file"
                  name="withId"
                  ref="withIdImg"
                  @change="setFile"
                  style="display: none"
                />
                <button
                  size="small"
                  class="black ml6"
                  type="primary"
                  @click.prevent="$refs.withIdImg.click()"
                >
                  {{ $t("verificationReset.residence.findFile") }}
                </button>
              </div>
              <div class="img-box mt10" flex fjs fie>
                <ul>
                  <li
                    v-html="
                      `- ${$t(`verificationReset.residence.photo.content[0]`)}`
                    "
                  />
                  <li
                    v-html="
                      `- ${$t(`verificationReset.residence.photo.content[1]`)}`
                    "
                  />
                </ul>
              </div>
            </div>
          </div>
          <!-- RECAPTCHA//S -->
          <!-- google recaptcha -->
          <div class="recaptcha">
            <div class="allibaba">
              <allibaba
                @send-response-data-event="getResponseData"
                :swapvisible="false"
                ref="alibaba"
              ></allibaba>
            </div>
          </div>
          <!-- RECAPTCHA//E -->

          <div class="w12 button-box mt30 pb40" flex>
            <button
              class="cancel white"
              @click.prevent="$router.push('/mypage/auth')"
            >
              취소
            </button>
            <button class="submit ml10" @click.prevent="requestResidence">
              서류 등록
            </button>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";
import allibaba from "../../../components/login/allibaba";

import MypageHeader from "../component/mypage/header.vue";

export default {
  components: {
    MypageHeader,
    allibaba,
  },
  data() {
    return {
      uploadModalScrollEnd: false,
      fileList: [],
      files: {
        idCard: {},
        withId: {},
      },
      ali_response: null,
    };
  },
  methods: {
    onUploadScroll(e) {
      const scrollEnd = e.target.scrollHeight - e.target.offsetHeight - 10;
      if (scrollEnd < e.target.scrollTop) {
        this.uploadModalScrollEnd = true;
      }
    },
    setFile($event) {
      const { name, files } = $event.target;
      if (!files.length) {
        return false;
      }
      // size 체크
      const fileMaxSize = 10485760;
      if (
        files[0].size > fileMaxSize ||
        !/\.(jpg|jpeg|png)$/i.test(files[0].name)
      ) {
        this.$vs.notify({
          text: "You can upload Less than 10MB / Attach JPG image file only.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }
      this.files[name] = files[0];
    },
    requestResidence() {
      // 세 파일 다 업로드 되었는지 판단
      if (_.some(this.files, (f) => !(f instanceof File))) {
        this.$vs.notify({
          text: "Please upload all of pictures.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }

      // 알리슬라이드 완료 확인
      if (this.ali_response == null) {
        this.$vs.notify({
          text: "Please verify the slide.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }
      const { ali_token, ali_sig, ali_csessionid } = this.ali_response
        ? this.ali_response
        : {};

      Api.User.RequestKYCAuth({
        upfile1: this.files.idCard,
        upfile2: this.files.withId,
        ali_token,
        ali_sig,
        ali_csessionid,
      }).then((response) => {
        // this.$vs.notify({
        //   text: "Requeist of Identify verification is complete.",
        //   position: "top-left",
        // });

        this.$msgbox({
          title: "",
          message: "Requeist of Identify verification is complete.",
          customClass: "auth-success",
          confirmButtonText: this.$t("confirm.ok"),
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
        });
        this.$emit("success");
        // this.residenceCancel();
        this.$router.push("/mypage/auth");
      });
    },
    residenceCancel() {
      this.files = {
        idCard: {},
        withId: {},
      };
      this.uploadModalScrollEnd = false;
      this.$refs.uploadScroll.scrollTo(0, 0);
      this.$emit("close");
      this.$refs.alibaba.aliSlideReset();
    },
    getResponseData(data) {
      // data = rcapt_id || ali_response
      if (!isNaN(data)) {
        this.rcapt_id = data;
        this.ali_response = null;
      } else {
        this.rcapt_id = null;
        this.ali_response = data;
      }
    },
  },
};
</script>
